import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MessageInterface } from '@app/interface/messages';

export interface MessageDetailData {
  message: MessageInterface;
}

@Component({
  selector: 'izy-message-detail-bottom-sheet',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatChipsModule,
    MatDividerModule,
    MatCardModule,
  ],
  templateUrl: './message-detail-bottom-sheet.component.html',
  styleUrl: './message-detail-bottom-sheet.component.scss',
})
export class MessageDetailBottomSheetComponent {
  constructor(
    private _bottomSheetRef: MatBottomSheetRef<MessageDetailBottomSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: MessageDetailData
  ) {}

  getMessageTypeColor(type: 'IN' | 'OUT'): string {
    return type === 'IN' ? 'primary' : 'accent';
  }

  getMessageTypeIcon(type: 'IN' | 'OUT'): string {
    return type === 'IN' ? 'mail' : 'upload';
  }

  getMessageTypeLabel(type: 'IN' | 'OUT'): string {
    return type === 'IN' ? 'In arrivo' : 'Inviato';
  }

  hasAttachment(message: MessageInterface): boolean {
    return !!message.attached_file;
  }

  downloadAttachment(): void {
    if (this.data.message.attached_file) {
      window.open(this.data.message.attached_file, '_blank');
      this._bottomSheetRef.dismiss();
    }
  }

  formatDate(dateString: string): string {
    return new Date(dateString).toLocaleDateString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }

  closeBottomSheet(): void {
    this._bottomSheetRef.dismiss();
  }
}
